import { render, staticRenderFns } from "./Gewinnspiel.vue?vue&type=template&id=56605ed2&scoped=true&"
import script from "./Gewinnspiel.vue?vue&type=script&lang=js&"
export * from "./Gewinnspiel.vue?vue&type=script&lang=js&"
import style0 from "./Gewinnspiel.vue?vue&type=style&index=0&id=56605ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56605ed2",
  null
  
)

export default component.exports